$(document).ready(function() {
    /* reset */
    $('.search-realties-form .reset').click( function() {
        $(this).closest('.search-realties-form').find('input').val('')
        $(this).closest('.search-realties-form').find('select').find('option:first').prop("selected", true);
    })
})